import { root, id } from './download';

export const download = {
  ...root,
  id,
};
